import objectFitImages from 'object-fit-images';

import Home from './renderers/home';
import Page from './renderers/page';
import Contact from './renderers/contact';
import Nav from './components/nav';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    const classes = document.body.classList;
    switch ( true ) {
		case classes.contains('home'):
			new Home();
		break;

		case classes.contains('page-template-page-adhesion'):
			new Contact();
		break;

		default:
			new Page();
	}

    new Nav();
});